<template>
  <GuToastProvider />

  <PageLayout>
    <RouterView />
  </PageLayout>
</template>

<script setup>
import { RouterView } from 'vue-router'

import PageLayout from '@shared/components/PageLayout.vue'
import { GuToastProvider } from '@shared/gu-components/toast'
</script>
